import { CompactCard } from "@jambushrushti/components/ui/content-card";

interface SimilarItem {
  id: string | number;
  title: string;
  image: string;
  category?: string;
  subtitle?: string;
}

interface SimilarItemsProps {
  title?: string;
  subtitle?: string;
  items: SimilarItem[];
  basePath: string;
  maxItems?: number;
}

export function SimilarItems({
  title = "Similar Items",
  subtitle,
  items,
  basePath,
  maxItems = 4,
}: SimilarItemsProps) {
  if (items.length === 0) {
    return null;
  }

  return (
    <section className="bg-gradient-spiritual relative overflow-hidden py-16">
      {/* Decorative Pattern */}
      <div className="lotus-pattern absolute inset-0 opacity-30" />

      <div className="container relative z-10 mx-auto px-4">
        <div className="mb-10 text-center">
          {subtitle && (
            <span className="text-xs font-medium uppercase tracking-widest text-primary">
              {subtitle}
            </span>
          )}
          <h2 className="font-display mt-2 text-2xl font-bold text-foreground lg:text-3xl">
            {title}
          </h2>
        </div>

        <div className="mx-auto grid max-w-4xl grid-cols-2 gap-6 md:grid-cols-4">
          {items.slice(0, maxItems).map((item, index) => (
            <CompactCard
              key={item.id}
              href={`${basePath}/${item.id}`}
              image={item.image}
              title={item.title}
              subtitle={item.subtitle}
              badge={item.category}
              index={index}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
